const {
    REACT_APP_MQTT_PROTOCOL,
    REACT_APP_MQTT_HOST,
    REACT_APP_MQTT_PORT,
    REACT_APP_MQTT_USERNAME,
    REACT_APP_MQTT_PASSWORD,
    REACT_APP_MQTT_MAIN_TOPIC,
    REACT_APP_API_BASE_URL,
    REACT_APP_DEBUG,
    REACT_APP_ENV
} = process.env

export const config = {
    mqtt: {
        protocol: REACT_APP_MQTT_PROTOCOL,
        host: REACT_APP_MQTT_HOST,
        port: REACT_APP_MQTT_PORT,
        username: REACT_APP_MQTT_USERNAME,
        password: REACT_APP_MQTT_PASSWORD,
    },
    appENV: REACT_APP_ENV,
    debug: REACT_APP_DEBUG === 'true',
    apiBaseURL: REACT_APP_API_BASE_URL,
    timeout: 5000,
    mqttMainTopic: REACT_APP_MQTT_MAIN_TOPIC
};